export default "__VITE_ASSET__SrqdS$$h__"